import React, { useState, useEffect } from 'react';
import './style.css'
import { Link } from 'react-router-dom';
import AlertBox from '../AlertBox/AlertBox'
import SpinnerLoader from '../SpinnerLoader/SpinnerLoader';
const axios = require('axios')
const { API_URL } = require('../../MetaData/Metadata');

const ChooseNME = () => {

    const NME_SUBJECT_SAVE_SUCCESS_MESSAGE = "NME Subject chosen successfully, you can find the details in your home page";
    const DEFAULT_ERROR_MESSAGE = "Something went wrong"
    const defaultAlertboxProps = { alertType: "info", heading: "For your Information", message: "Please go back to the home page" };

    const [isLoading, setIsLoading] = useState(false);
    const [listResponse, setListResponse] = useState([]);
    const [isEligible, setIsEligible] = useState(false); // Is the Student elligible to choose NME
    const [selectedSubject, setSelectedSubject] = useState(null) // this will hold the subject id selected by the student in the options
    const [alertBoxProps, setAlertBoxProps] = useState(defaultAlertboxProps);

    const onSelectedSubjectChange = event => {
        setSelectedSubject(event.target.value)
    }

    // Get general information
    const getNMESubjectList = async () => {
        try {
            setIsLoading(true);
            const apiRoute = `${API_URL}/student/nmeatbt/list`;
            const xAuthToken = localStorage.getItem('token');
            const axiosRequest = await axios({
                method: 'post',
                url: apiRoute,
                headers: { 'x-auth-token': xAuthToken },
            })
            const response = await axiosRequest;
            setListResponse(response.data.subjectList);
            console.log(response.data.subjectList)
            setIsEligible(true);
            setIsLoading(false);
        } catch (error) {
            setAlertBoxProps({ ...alertBoxProps, alertType: 'danger', message: error.response.data.message })
            setIsEligible(false);
            setIsLoading(false);
            console.error(error.response)
        }
    }

    // On Submit Button Click Save the Subject
    const onSubmit = async (e) => {
        e.preventDefault();
        if (selectedSubject) {
            console.log(selectedSubject)
            try {
                setIsLoading(true);
                const apiRoute = `${API_URL}/student/nmeatbt/save`;
                const xAuthToken = localStorage.getItem('token');
                const axiosRequest = await axios({
                    method: 'post',
                    url: apiRoute,
                    headers: { 'x-auth-token': xAuthToken },
                    data: { 'nmeatbt_id': selectedSubject }
                })
                const response = await axiosRequest;
                console.log(response.data)
                setAlertBoxProps({
                    ...alertBoxProps, alertType: 'success', message: NME_SUBJECT_SAVE_SUCCESS_MESSAGE
                })
                setIsEligible(false);
                setIsLoading(false);
                // getNMESubjectList();
            } catch (error) {
                setAlertBoxProps({ ...alertBoxProps, alertType: 'danger', message: DEFAULT_ERROR_MESSAGE })
                setIsEligible(false);
                setIsLoading(false);
                console.error(error.response)
            }
        }
        else return
    }

    const NMESubjectChooserComponent = () => {
        return (
            <div>
                <div className="container">
                    <div className="text-center">
                        <h2>NME Subject Chooser</h2>
                    </div>
                    <h5>Choose a subject from the following </h5>
                    <table className="table">
                        <thead>
                            <tr>
                                <th>Subject Code</th>
                                <th>Subject Name</th>
                                <th>Department</th>
                            </tr>
                        </thead>
                        {listResponse.map((subject) => {
                            return (
                                <tbody>
                                    <tr>
                                        <td><input
                                            type="radio"
                                            name={subject.subject_code}
                                            value={subject._id}
                                            checked={subject._id === selectedSubject}
                                            onClick={onSelectedSubjectChange} /> {subject.subject_code}</td>
                                        <td>{subject.name}</td>
                                        <td>{subject.department_handling.department}</td>
                                    </tr>
                                </tbody>
                            )
                        })}
                    </table>
                </div>
                <div className="text-center">
                    <p className="text-warning"></p>
                    <div className="alert alert-warning container">
                        <p><b>Note!</b> You cannot change your NME once you saved through online</p>
                    </div>
                    <button type="button" className="btn btn-primary" onClick={onSubmit}>Save</button>
                </div>
            </div>
        );
    }

    const renderAlertBox = () => {
        const { alertType, heading, message } = alertBoxProps;
        return (
            <AlertBox alertType={alertType} heading={heading} message={message} />
        )
    }

    useEffect(() => {
        getNMESubjectList()
    }, [])

    useEffect(() => {
    }, [isEligible])


    // Main Return
    return (
        <div>
            {isLoading ?
                <SpinnerLoader />
                :
                <div>
                    {isEligible ? NMESubjectChooserComponent() : renderAlertBox()}
                </div>
            }
            <div className="text-center">
                <Link to='/' className="btn btn-success mt-3">Go to Home Page</Link>
            </div>
        </div>
    )

}

export default ChooseNME;